import cloneDeep from 'lodash-es/cloneDeep';

export default (rawData, table) => {
    const columns = table.columns;

    const id = rawData[table.idField];

    /* if (id == undefined || id === '') {
        throw new Error(`
            [FlexTable] Error, no value found for row id field ('${table.idField}').
            Did you set the 'id-field' prop correctly? ${JSON.stringify(rawData)}
        `, )
    } */

    // Create display data
    const displayData = cloneDeep(rawData);
    columns.forEach(column => {
        const value = column.getDisplayValue(displayData);
        if (value !== null) {
            displayData[column.name] = value;
        }
    });

    // Create filter data
    const filterData = columns
        .filter(x => x.searchable)
        .reduce(
            (data, column) => ({
                ...data,
                [column.name]: column.getFilterValue(displayData),
            }),
            {},
        );
    const searchFilterData = Object.values(filterData);

    // Create sort data
    const sortData = columns
        .filter(x => x.sortable)
        .reduce(
            (data, column) => ({
                ...data,
                [column.name]: column.getSortValue(rawData, displayData),
            }),
            {},
        );

    const row = {
        id,
        rawData,
        displayData,
        filterData,
        sortData,
        data: displayData, // Alias
    };

    row.check = val => table.$emit('check-row', row, val);

    row.isChecked = () => table.checkedRowIds.includes(row.id);

    row.passesSearchFilter = text =>
        text !== '' ? searchFilterData.find(str => str.includes(text)) : true;

    return row;
};
